import React, {useRef, useState} from "react";
import TopNavigation from "../components/TopNavigation";
import "./Home.css";

import videoName from "../assets/MicahAlyseHomeBanner-short.mp4";
import work1 from "../assets/VIGOR Magazine/Vigor_HomePage.png";
import work5 from "../assets/Asensio Soccer Store/Asensio-HomePage.png";

import branding from "../assets/branding.png";
import audience from "../assets/audience.png";
import not_sure_yet from "../assets/not-sure-yet.png";
import {Link, useNavigate} from "react-router-dom";

const expertiseDetails = {
    branding: {
        display: "branding",
        title: "Branding",
        description:
            "A strategic process to develop a name, logo, and color palette. Every client is involved in bringing their most effective and recognizable brand to life.",
    },
    marketing: {
        display: "marketing",
        title: "Marketing",
        description:
            "Creating highly effective designs and advertising strategies to reach target audiences and promote products.",
    },
    print: {
        display: "print",
        title: "Print Design",
        description:
            "Using tangible surfaces to communicate messages, including business cards, brochures, maps, packaging, booklets, posters, signage, and backdrops.",
    },
    social: {
        display: "social media",
        title: "Social Media",
        description:
            "Designing social assets that build brand awareness and attract attention across platforms such as Facebook, Instagram, Twitter, and blogs.",
    },
    photography: {
        display: "photo",
        title: "Photography",
        description:
            "With experience in photography and photo editing within Lightroom and Photoshop, I enhance design projects with cohesiveness and functionality.",
    },
    website: {
        display: "web",
        title: "Website",
        description:
            "Crafting functional and engaging websites using platforms like WordPress or Squarespace, with minimal HTML and CSS.",
    },
};

const Home = () => {

    const navigate = useNavigate(); // Initialize useNavigate

    const videoRef = useRef(null);
    const [fade, setFade] = useState(false);
    let fadeTimeout;

    const [activeExpertise, setActiveExpertise] = useState(null); // Track the active expertise

    // const images = [work5, work1];
    // const [currentIndex, setCurrentIndex] = useState(0);

    const handleTimeUpdate = () => {
        const video = videoRef.current;

        if (video) {
            const timeLeft = video.duration - video.currentTime;

            // Trigger the fade effect with a delay
            if (timeLeft <= 1) {
                if (!fadeTimeout) {
                    fadeTimeout = setTimeout(() => {
                        setFade(true);
                    }, 500); // Delay of 500ms before fading
                }
            } else {
                clearTimeout(fadeTimeout);
                fadeTimeout = null;
                setFade(false);
            }
        }
    };

    // Navigate to the next image
    // const handleNext = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    // };
    //
    // // Navigate to the previous image
    // const handlePrevious = () => {
    //     setCurrentIndex((prevIndex) =>
    //         prevIndex === 0 ? images.length - 1 : prevIndex - 1
    //     );
    // };

    const handleExploreMoreClick = () => {
        navigate("/work"); // Redirect to /work
    };

    const handleExpertiseClick = (key) => {
        setActiveExpertise((prev) => (prev === key ? null : key)); // Toggle expertise
    };

    return (
        <div>
            <TopNavigation/>
            {/* Home Section */}
            <section className="home">
                {/* Video Background */}
                <video
                    ref={videoRef}
                    className="background-video"
                    src={videoName}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onTimeUpdate={handleTimeUpdate}
                ></video>

                {/* Black Overlay for Fade Effect */}
                <div className={`fade-overlay ${fade ? "fade-in" : ""}`}></div>

                {/* Overlay Text */}
                <div className="overlay-text">
                    <h1>bring <br/> your <br/> vision <br/> to life.</h1>
                </div>
            </section>


            {/* Designs That Matter Section */}
            <section className="designs-section">
                <div className="designs-background">
                    <div className="designs-container">
                        {/* Image Display */}
                        <div className="designs-image">
                            <img src={work5} alt="Design" onClick={handleExploreMoreClick}/>
                            {/*<div className="navigation-buttons">*/}
                            {/*    <button onClick={handlePrevious} className="prev-button">*/}
                            {/*        ←*/}
                            {/*    </button>*/}
                            {/*    <button onClick={handleNext} className="next-button">*/}
                            {/*        →*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                        </div>

                        {/* Text Content */}
                        <div className="designs-content">
                            <h2>designs that matter</h2>
                            <button
                                className="explore-button"
                                onClick={handleExploreMoreClick}
                            >
                                Explore More
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="expertise-section">
                <div className="expertise">
                    <div>
                        {Object.keys(expertiseDetails).map((key) => (
                            <div key={key} className="expertise-item-container">
                                <p
                                    key={key}
                                    onClick={() => handleExpertiseClick(key)}
                                    className="expertise-item"
                                >
                                    {expertiseDetails[key].display}

                                    {activeExpertise === key && (
                                        <div className="expertise-description">
                                            <p>{expertiseDetails[key].description}</p>
                                        </div>
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                    <div className="gap">
                        <div className="divider" style={{backgroundColor: '#A5BDC2', height: '420px'}}></div>
                    </div>
                    <div className="expertise-label">
                        <p>expertise</p>
                    </div>
                </div>
            </section>

                {/*<div className="modal-overlay" onClick={closeModal}>*/}
                {/*    <div className="modal-content" onClick={(e) => e.stopPropagation()}>*/}
                {/*        <span className="close-modal" onClick={closeModal}>*/}
                {/*            &times;*/}
                {/*        </span>*/}
                {/*        <div className="expertise-details">*/}
                {/*            {Object.entries(expertiseDetails).map(([key, value]) => (*/}
                {/*                <div key={key} className="expertise-detail">*/}
                {/*                    <h3>{value.title}</h3>*/}
                {/*                    <p>{value.description}</p>*/}
                {/*                </div>*/}
                {/*            ))}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}


            <section className="process-section">

                <div className="designs-background">
                    <div className="designs-container">
                        {/* Text Content */}
                        <div className="designs-content">
                            <h2 style={{lineHeight: '0.9', marginBottom: '60px'}}>
                                where <br/> ideas <br/> become <br/>
                                a vibrant <br/> reality
                            </h2>
                            <button
                            className="explore-button" style={{backgroundColor: '#C39552'}}
                                onClick={handleExploreMoreClick}
                            >
                                Explore More
                            </button>
                        </div>

                        {/* Image Display */}
                        <div className="designs-image">
                            <img src={work1} alt="Design 2" onClick={handleExploreMoreClick}/>
                        </div>
                    </div>
                </div>

                <div className="process-container">
                    <h2 className="process-title">our process</h2>
                    <div className="process-steps">
                        <div className="step">
                            <div className="step-number" style={{backgroundColor: '#A5BDC2'}}>1</div>
                            <h3 className="step-title" style={{color: '#A5BDC2'}}>Strategize</h3>
                            <p className="step-description">Collaborate with the client to define the concept</p>
                        </div>
                        <div className="divider"></div>
                        <div className="step">
                            <div className="step-number">2</div>
                            <h3 className="step-title">Create</h3>
                            <p className="step-description">Research & develop ideas into drafts</p>
                        </div>
                        <div className="divider"></div>
                        <div className="step">
                            <div className="step-number" style={{backgroundColor: '#61818B'}}>3</div>
                            <h3 className="step-title" style={{color: '#61818B'}}>Refine</h3>
                            <p className="step-description">Perfect & deliver the final product</p>
                        </div>
                    </div>

                </div>
            </section>


            <section className="looking-for-section">
                <div className="looking-for-container">
                    {/* Title */}
                    <div className="looking-for-container-title">
                        <h2>what are you <br/> looking for?</h2>
                    </div>

                    {/* Options */}
                    <div className="options">
                        <div className="option">
                            <img src={branding} alt="Branding"/>
                            <div className="overlay">
                                <span>BRANDING</span>
                            </div>
                        </div>
                        <div className="option">
                            <img src={audience} alt="Marketing"/>
                            <div className="overlay">
                                <span>MARKETING</span>
                            </div>
                        </div>
                        <div className="option">
                            <img src={not_sure_yet} alt="Not Sure Yet"/>
                            <div className="overlay">
                                <span>NOT SURE YET</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Explore More */}
                <div className="explore-more">
                    <h2>
                        explore <br/>
                        more <span className="arrow">→</span>
                    </h2>
                </div>
            </section>

            <section className="need-design-section">
                <div className="design-content">
                    <h1>need a <br/> design?</h1>
                </div>
                <div className="design-content-start">
                    <Link to="/contact" style={{textDecoration: 'none', color: 'inherit'}}>
                        <h1>
                            <span className="arrow">→</span> start here
                        </h1>
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default Home;
